import { TrackingEvent } from '../../../types/tracking-events.enum';
import { VisitCardTypeEnum } from '../../../types/visit-card-type.enum';
import {
    VisitCardType,
    VisitCardWithButton,
} from '../../../types/visit-card.type';

export const VisitCardMap: Map<
    VisitCardTypeEnum,
    VisitCardWithButton | VisitCardType
> = new Map([
    [
        VisitCardTypeEnum.PAQ,
        {
            title: 'visits.paq.title',
            text: 'visits.paq.text',
            image: 'pre-arrival-questionnaire-lanai.jpg',
            activeButtonLabel: 'visits.paq.activeButton',
            disabledButtonLabel: 'visits.paq.disabledButton',
            infoText: 'visits.paq.infoText',
            trackingEvent: TrackingEvent.PAQ_CLICKED,
        },
    ],
    [
        VisitCardTypeEnum.ITINERARY,
        {
            title: 'visits.itinerary.title',
            text: 'visits.itinerary.text',
            image: 'your-itinerary-lanai.jpg',
            activeButtonLabel: 'visits.itinerary.activeButton',
            disabledButtonLabel: 'visits.itinerary.disabledButton',
            trackingEvent: TrackingEvent.ITINERARY_CLICKED,
        },
    ],
    [
        VisitCardTypeEnum.PACKING_LIST,
        {
            title: 'visits.packingList.title',
            text: 'visits.packingList.text',
            image: 'your-packing-list-lanai.jpg',
            activeButtonLabel: 'visits.packingList.activeButton',
            disabledButtonLabel: 'visits.packingList.disabledButton',
            trackingEvent: TrackingEvent.PACKING_LIST_CLICKED,
        },
    ],
    [
        VisitCardTypeEnum.ACTIVITY_CALENDAR,
        {
            title: 'visits.activityCalendar.title',
            text: 'visits.activityCalendar.text',
            image: 'activity-calendar-lanai.jpg',
            trackingEvent: TrackingEvent.ACTIVITY_CALENDAR_CLICKED,
            activeButtonLabel: 'visits.activityCalendar.activeButton',
        },
    ],
    [
        VisitCardTypeEnum.EXPERIENCES_MENU,
        {
            title: 'visits.experiencesMenu.title',
            text: 'visits.experiencesMenu.text',
            image: 'experiences-menu-lanai.jpg',
            trackingEvent: TrackingEvent.EXPERIENCES_MENU_CLICKED,
            activeButtonLabel: 'visits.experiencesMenu.activeButton',
        },
    ],
    [
        VisitCardTypeEnum.PROPERTY_MAP,
        {
            title: 'visits.propertyMap.title',
            text: 'visits.propertyMap.text',
            image: 'property-map-lanai.png',
            trackingEvent: TrackingEvent.PROPERTY_MAP_CLICKED,
            activeButtonLabel: 'visits.propertyMap.activeButton',
        },
    ],
]);
